/* global window */
import * as React from "react";
import { Toast, ToastBody, Toaster, ToastTitle, useId, useToastController } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const GlobalToast = () => {
  const { t } = useTranslation();
  const toasterId = useId("globalToaster");
  const { dispatchToast } = useToastController(toasterId);

  const notifyToast = (intent, title, body, params) => {
    dispatchToast(
      <Toast>
        <ToastTitle>{t(title, params)}</ToastTitle>
        {body ? <ToastBody>{t(body, params)}</ToastBody> : <></>}
      </Toast>,
      { intent }
    );
  };

  window.notifyToast = notifyToast;

  return <Toaster toasterId={toasterId} />;
};

export default GlobalToast;

export const notify = (intent, title, body, params) => {
  window.notifyToast(intent, title, body, params);
};
